// @flow
import React from 'react';

type Props = {
  amount: string,
  hblUrl: string,
  trekId?: string,
  invoiceNo: string,
  invoiceId: string,
  hashValue: string,
  nonSecure: string,
  amountInUSD: string,
  currencyCode: string,
  hblPaymentGatewayId: string,
  // trekStartDate?: string,
};

export const HBL_FORM_ID = 'hblPaymentForm';

// A Variable to set input type
const inputType = 'hidden';

const HimalayanBankForm = ({
  trekId,
  hblUrl,
  amount,
  invoiceNo,
  invoiceId,
  nonSecure,
  hashValue,
  currencyCode,
  hblPaymentGatewayId,
  // amountInUSD,
}: // trekStartDate,
Props) => {
  return (
    <form action={hblUrl} method="post" id={HBL_FORM_ID}>
      {/* ====================================================================
        Payment Gateway ID as stated in HBL PGW Merchant Reporting
        LENGTH = 15
     */}

      <input
        type={inputType}
        id="paymentGatewayID"
        name="paymentGatewayID"
        value={hblPaymentGatewayId}
      />
      {/* ================================================================= */}

      {/* ====================================================================
        Provided by Merchant. The invoice number needs to be unique to trace the
        transaction. Please pad ‘0’ to the left in the case of generated invoice number
        length is shorter than 20.
        LENGTH = 20
      */}

      <input type={inputType} id="invoiceNo" name="invoiceNo" value={invoiceNo} />
      {/* ================================================================= */}

      {/* ====================================================================
        The product description which is provided from merchant.
        LENGTH = 50
      */}

      <input type={inputType} id="productDesc" name="productDesc" value="Flight Tickets" />
      {/* ================================================================= */}

      {/* ====================================================================
        The amount will be padded with ‘0’ from the left and include no
        decimal point. Example: 1 = 000000000100, 1.5 = 000000000150
        LENGTH = 12
       */}

      <input type={inputType} id="amount" name="amount" value={amount} />
      {/* ================================================================= */}

      {/* ====================================================================
        CurrencyCode   Currency Name
        524            Nepalese Rupee
        840            United States dollar
      */}

      <input type={inputType} id="currencyCode" name="currencyCode" value={currencyCode} />
      {/* ================================================================= */}

      {/* ====================================================================
        User defined info from request message
        Possible fields userDefined1 - userDefined5
        LENGTH = 150
       */}

      {trekId && (
        <input type={inputType} id={'userDefined1'} name={'userDefined1'} value={trekId} />
      )}
      {invoiceId && (
        <input
          type={inputType}
          id={'userDefined2'}
          name={'userDefined2'}
          value={invoiceId}
        />
      )}

      {/* userDefined3 and 4 are not in use because of bug in HBL payment api. */}
      {/* <input type={inputType} id={'userDefined3'} name={'userDefined3'} value={3} /> */}
      {/* <input type={inputType} id={'userDefined4'} name={'userDefined4'} value={4} /> */}

      {/* <input
        type={inputType}
        id={'userDefined5'}
        name={'userDefined5'}
        value={amountInUSD}
      /> */}

      {/* ================================================================= */}

      {/* ====================================================================
        This parameter is optional to indicate payment without 3D secure authentication.
        value Y and N for Yes and No.
      */}

      <input type={inputType} id="nonSecure" name="nonSecure" value={nonSecure} />
      {/* ================================================================= */}

      {/* ====================================================================
        Hash value computed by SHA-2 with secret key provided by HBL
        LENGTH  = 150
      */}

      <input type={inputType} id="hashValue" name="hashValue" value={hashValue} />
      {/* ================================================================= */}
    </form>
  );
};

export default HimalayanBankForm;

// Export HBL_USER_DEFINED_FIELDS as it is a mapping of userDefined variables
type HbluserDefinedFields = {
  userDefined1: 'trekId',
  userDefined2: 'invoiceId',
  userDefined3: null,
  userDefined4: null,
  userDefined5: 'amountInUSD',
};

export const HBL_USER_DEFINED_FIELDS: HbluserDefinedFields = {
  userDefined1: 'trekId',
  userDefined2: 'invoiceId',
  userDefined3: null,
  userDefined4: null,
  userDefined5: 'amountInUSD',
};



// WEBPACK FOOTER //
// ./src/screens/Flights/Review/HimalayanBankForm.js